(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-engagement-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!window.GrowplayCollectionEngagementGallery) {
    window.GrowplayCollectionEngagementGallery = true;

    const getSection = (element) => element.closest('.collection-engagement-gallery');
    const getTriggers = (section) => Array.from(section.querySelectorAll('[data-gallery-trigger]'));

    const showImage = (section, index) => {
      const triggers = getTriggers(section);
      const safeIndex = (index + triggers.length) % triggers.length;
      const trigger = triggers[safeIndex];
      const dialog = section.querySelector('[data-gallery-dialog]');
      const image = dialog.querySelector('[data-gallery-dialog-image]');
      const caption = dialog.querySelector('[data-gallery-dialog-caption]');

      section.dataset.galleryCurrentIndex = String(safeIndex);
      image.src = trigger.dataset.fullImage;
      image.alt = trigger.dataset.alt;
      caption.textContent = trigger.dataset.alt;
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-gallery-trigger]');
      const close = event.target.closest('[data-gallery-close]');
      const previous = event.target.closest('[data-gallery-prev]');
      const next = event.target.closest('[data-gallery-next]');

      if (trigger) {
        const section = getSection(trigger);
        const dialog = section.querySelector('[data-gallery-dialog]');
        showImage(section, Number(trigger.dataset.galleryIndex));
        dialog.showModal();
      }

      if (close) {
        close.closest('[data-gallery-dialog]').close();
      }

      if (previous || next) {
        const section = getSection(event.target);
        const currentIndex = Number(section.dataset.galleryCurrentIndex || 0);
        showImage(section, previous ? currentIndex - 1 : currentIndex + 1);
      }
    });

    document.addEventListener('click', (event) => {
      const dialog = event.target.closest('[data-gallery-dialog]');

      if (dialog && event.target === dialog) {
        dialog.close();
      }
    });

    document.addEventListener('keydown', (event) => {
      const dialog = document.querySelector('[data-gallery-dialog][open]');

      if (!dialog) {
        return;
      }

      const section = getSection(dialog);
      const currentIndex = Number(section.dataset.galleryCurrentIndex || 0);

      if (event.key === 'ArrowLeft') {
        showImage(section, currentIndex - 1);
      }

      if (event.key === 'ArrowRight') {
        showImage(section, currentIndex + 1);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
